import React from 'react';
import {
  Button, Col, Form, Input, message, Modal, Row, Segmented, Select, Upload,
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import axios from 'axios';
import PropTypes from 'prop-types';

const EditModal = ({
  editingRow = null,
  isOpen = false,
  availableUsersOptions = [],
  availableBoardsOptions = [],
  onClose = (_) => {},
}) => {
  const [messageApi, contextHolder] = message.useMessage();

  const handleSubmit = (values) => {
    const csrf = document.head.querySelector("[name='csrf-token']").content;

    axios({
      headers: { 'X-CSRF-Token': csrf },
      method: 'put',
      url: `/tickets/${editingRow?.id}`,
      data: values,
    }).then((response) => {
      messageApi.success('Зміни успішно збережені');
      onClose(values);
    }).catch((error) => {
      const errorMessage =
        error?.response?.data?.errors?.join('; ') || 'Помилка при збереженні змін';
      messageApi.error(errorMessage);
      console.error(error);
    });
  };

  return (
    <Modal
      title={`#${editingRow?.number}`}
      open={isOpen}
      onCancel={() => onClose(null)}
      footer={null}
      width={1000}
      destroyOnHidden
    >
      {contextHolder}
      <Form
        initialValues={editingRow}
        onFinish={handleSubmit}
        preserve={false}
        variant="filled"
      >
        <Row gutter={5}>
          <Col span={16}>
            <Form.Item name="title">
              <Input />
            </Form.Item>
            <Form.Item name="description">
              <Input.TextArea autoSize={{ minRows: 10, maxRows: 17 }} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="status">
              <Segmented
                options={[
                  { value: 'open', label: 'Нова' },
                  { value: 'in_progress', label: 'В роботі' },
                  { value: 'closed', label: 'Закрита' },
                ]}
              />
            </Form.Item>
            <Form.Item name="user_id">
              <Select
                placeholder="Автор"
                options={availableUsersOptions}
                showSearch
                allowClear
              />
            </Form.Item>
            <Form.Item name="responsible_id">
              <Select
                placeholder="Виконавець"
                options={availableUsersOptions}
                showSearch
                allowClear
              />
            </Form.Item>
            <Form.Item name="board_id">
              <Select
                placeholder="Достка"
                options={availableBoardsOptions}
                showSearch
                allowClear
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          name="attachments"
          valuePropName="fileList"
          getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
        >
          <Upload
            name="file"
            action={`/attachments?attachable_type=Ticket&attachable_id=${editingRow?.id}`}
            listType="picture-card"
          >
            <Button type="text" icon={<UploadOutlined />} />
          </Upload>
        </Form.Item>
        <Button type="primary" htmlType="submit">Зберегти</Button>
      </Form>
    </Modal>
  );
};

EditModal.propTypes = {
  editingRow: PropTypes.shape({
    id: PropTypes.number.isRequired,
    number: PropTypes.string.isRequired,
    status: PropTypes.oneOf(['open', 'in_progress', 'closed']),
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    authorId: PropTypes.number.isRequired,
    authorName: PropTypes.string.isRequired,
  }),
  isOpen: PropTypes.bool,
  availableUsersOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
  })),
  availableBoardsOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
  })),
  onClose: PropTypes.func,
};

export default EditModal;
